import type { FieldSchemaModel, SavedFilterType } from '@/shared/generated'
import type { DataChoicesRegistry } from '../filter/types'
import type { FilterSchema } from '../filter/validation'

import React, { useMemo } from 'react'
import { ListFilterIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { toAdaptedSchema } from '@/entities/column'

import FiltersPopover from '@/shared/components/filter/FiltersPopover'
import { StateButton } from '@/shared/components/ui/state-button'

type TableFiltersProps = {
	enableSaveFilters?: boolean
	enableRecentFilters?: boolean
	schema: FieldSchemaModel[]
	filters: FilterSchema[]
	onApply(filters: FilterSchema[]): void
	choices?: DataChoicesRegistry
	onAnalyticsApply?: () => void
	savedFiltersType?: SavedFilterType
}
export default function TableFilters({
	schema,
	filters,
	onApply,
	choices,
	enableSaveFilters,
	enableRecentFilters,
	onAnalyticsApply,
	savedFiltersType,
}: TableFiltersProps) {
	const { t } = useTranslation()

	const fields = useMemo(
		() => schema.map((schema) => toAdaptedSchema(schema, t)),
		[schema, t]
	)

	return (
		<FiltersPopover
			fields={fields}
			filters={filters ?? []}
			dataChoices={choices}
			onApply={(filters) => {
				onAnalyticsApply?.()
				onApply(filters)
			}}
			savedFiltersType={savedFiltersType}
			enableSaveFilters={enableSaveFilters}
			enableRecentFilters={enableRecentFilters}
		>
			<StateButton
				data-testid='table-filters-button'
				onClear={() => onApply([])}
				active={!!filters.length}
			>
				<ListFilterIcon />
				{`${t('general_filter')}`} {filters.length ? `(${filters.length})` : ''}
			</StateButton>
		</FiltersPopover>
	)
}
